var scope_0 = require('/home/thomas/ProNatura/github/wiesentour.ch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/36bda6d83b8cd4192fbce5f70191fc55.js').default;
var scope_1 = require('/home/thomas/ProNatura/github/wiesentour.ch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a6179a8a10a952dd477c8355c57eb0a9.js').default;
var scope_2 = require('/home/thomas/ProNatura/github/wiesentour.ch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/db15f5d5637e02163376d7ec284e829d.js').default;
var scope_3 = require('/home/thomas/ProNatura/github/wiesentour.ch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    